import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private cookieService: CookieService,
    public translate: TranslateService
  ) {
    this.translate.addLangs(["pt-br", "es"]);
    this.translate.setDefaultLang("pt-br");
    this.translate.use(this.cookieService.get("lang"));
  }

  ngOnInit() {
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  }
}
